import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { State, City } from '@/models/geo.model';

@Injectable({
  providedIn: 'root'
})
export class GeoService {
  private apiUrl = `${environment.apiUrl}/public/geo`;

  constructor(private http: HttpClient) {}

  /**
   * Get all states
   * @returns {Observable<State[]>} - Observable containing the states data
   */
  getEstados(): Observable<State[]> {
    return this.http.get<State[]>(`${this.apiUrl}/estados`);
  }

  /**
   * Get all cities
   * @returns {Observable<City[]>} - Observable containing the cities data
   */
  getCidades(): Observable<City[]> {
    return this.http.get<City[]>(`${this.apiUrl}/cidades`);
  }

  /**
   * Get cities by state ID
   * @param estadoId - The state ID to filter cities
   * @returns {Observable<City[]>} - Observable containing the filtered cities data
   */
  getCidadesByEstado(estadoId: number): Observable<City[]> {
    return this.http.get<City[]>(`${this.apiUrl}/cidades?estadoId=${estadoId}`);
  }
}
